module.exports = __webpack_public_path__ + "static/img/qy_webchart.a5351a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone/page/qy_webchart.png
// module id = G+8W
// module chunks = 1